import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function SnakesAndLadders() {
  return (
    <div className="p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Snakes and Ladders" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Snakes and Ladders</h1>
      <img
        src="/thumbnails/SnakesAndLadders.png"
        alt="Snakes and Ladders game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Snakes and Ladders</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Snakes and Ladders is a classic board game of luck and chance, enjoyed by players of all ages. Race to the finish as you climb ladders and avoid sliding down snakes. The first to reach the final square wins!
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Each player rolls a die and moves their token forward the number of spaces shown.</li>
          <li>If you land at the bottom of a ladder, climb up to the top of the ladder.</li>
          <li>If you land on the head of a snake, slide down to its tail.</li>
          <li>First player to reach the final square (with an exact roll) wins the game.</li>
          <li>If you roll too high to land exactly on the last square, you must wait and try again next turn.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Features</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Classic board design with colorful snakes and ladders</li>
          <li>Multiplayer online play with friends or family</li>
          <li>Simple, easy-to-learn rules for all ages</li>
          <li>Animated movement and fun sound effects</li>
          <li>Automatic win detection and fair dice rolls</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Tips & Tricks</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Try to land on ladders and avoid snakes, but remember it's all up to the dice!</li>
          <li>Play with friends for more excitement and unpredictable outcomes.</li>
          <li>Enjoy the game for its fun and surprises—winning is all about luck!</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Snakes and Ladders</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Play Snakes and Ladders online with friends or family—no download or registration required. See who can reach the top first!
        </p>
        <PlayGameLink game="SnakesAndLadders" gameTitle="Snakes and Ladders" />
      </section>
    </div>
  );
}
